import { Injectable } from '@angular/core';
import { AppConfig } from '../model/app-config';

@Injectable()
export class AppConfigService {
  readonly appConfig: AppConfig;
  readonly baseUrlFiles: string;

  constructor(appConfig: AppConfig) {
    this.appConfig = appConfig;
    this.baseUrlFiles = appConfig.azure.proxy_base_url + 'files';
  }
}
